import { ICartProps } from '../CartContext.types';
import {
    DefaultValidatePromoRequest,
    IAccessoryRequest,
    IValidatePromoRequest
} from './Promo.types';

const useValidatePromoRequestMapper = (cart: ICartProps): IValidatePromoRequest => {
    const request = DefaultValidatePromoRequest();

    cart.lineItems.forEach((l) => {
        const lineItem = {
            lineNumber: l.lineNumber,
            device: l.device?.product.id,
            plan: l.planSelection?.plan.id,
            assurance: l.device?.useAssurance,
            tradeInValue: l.device?.tradeIn?.price,
            downPayment: l.device?.downPayment
        };
        request.lineItems.push(lineItem);
    });

    cart.accessories.forEach((a) => {
        const accessoryItem: IAccessoryRequest = {
            accessory: a.product.id,
            quantity: a.quantity
        };

        if (a.quantity > 0) request.accessories.push(accessoryItem);
    });

    return request;
};

export default useValidatePromoRequestMapper;
